import {faSortAlt} from '@fortawesome/pro-duotone-svg-icons';
import {faXmark} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {useUpdate} from '@refinedev/core';
import {useBoolean} from 'minimal-shared/hooks';
import {useState} from 'react';

import {Indicator} from '../indicator-types';
import {IndicatorsOrder} from './indicators-order';

type Props = {
  indicators: Indicator[];
  onUpdate: () => void;
};

export const IndicatorOrderDrawer = ({indicators, onUpdate}: Props) => {
  const {onTrue: openDrawer, onFalse: closeDrawer, value: isOpen} = useBoolean();
  const [indicatorsState, setIndicatorsState] = useState<Indicator[]>(indicators);
  const {mutate} = useUpdate({
    mutationOptions: {
      onSuccess() {
        onUpdate();
        onClose();
      },
    },
  });

  const onOpen = () => {
    openDrawer();
  };

  const onClose = () => {
    closeDrawer();
  };

  const saveOrder = () => {
    try {
      const values = indicatorsState.map((indicator, index) => {
        return {indicator: indicator.uuid, ordre: index};
      });
      mutate({
        resource: 'pilotage/indicateur-tissot/order',
        id: '',
        values,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button variant="outlined" color="primary" onClick={onOpen}>
          <FontAwesomeIcon icon={faSortAlt} /> {"Définir l'ordre des indicateurs"}
        </Button>
      </Box>

      <Drawer
        open={isOpen}
        onClose={onClose}
        anchor="right"
        slotProps={{backdrop: {invisible: true}}}
        PaperProps={{sx: {width: '33%', minWidth: '500px'}}}
        hideBackdrop
        ModalProps={{disableEscapeKeyDown: true, keepMounted: true}}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={2}
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            bgcolor: 'background.paper',
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <IconButton onClick={onClose}>
            <FontAwesomeIcon icon={faXmark} size="xs" />
          </IconButton>
          <Button variant="contained" color="success" onClick={saveOrder}>
            Sauvegarder
          </Button>
        </Box>

        <Box sx={{m: 4, mt: 4, flexDirection: 'column'}}>
          <Typography variant="h4" color={'textSecondary'} sx={{mb: 2}}>
            {"Définissez l'ordre des indicateurs"}
          </Typography>

          <Box
            sx={{
              pt: 2,
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <IndicatorsOrder indicators={indicators} changeOrder={setIndicatorsState} />
          </Box>
        </Box>
      </Drawer>
    </>
  );
};
